import {Promise} from "es6-promise";

/**
 * Created by jv on 10/03/2017.
 */
// Styles
require("Libs/fontawesome/font-awesome.css");
require("cookieconsent/build/cookieconsent.min.css");
require("Libs/custom-scrollbar/jquery.mCustomScrollbar.css");

// js
//require("script-loader!Sources/misc/google-analytics");
require("babel-polyfill");
// Polyfill promises
require("es6-promise/auto");
require("Libs/bootstrap/js/index.umd");
// These libs aren't nice and put themselves in window instead of being able to be required into a variable
// prepend the JS files with 'script-loader?' to require them like they were added with ordinary <script> tags
// https://webpack.github.io/docs/shimming-modules.html
require("script-loader?Modernizr!Libs/Modernizr/modernizr-custom"); // Is used to check if browser is outdated
require("script-loader!cookieconsent/build/cookieconsent.min"); // requires the cookieconsent library like it was a script tag in the html
require("script-loader!Libs/custom-scrollbar/jquery.mCustomScrollbar.concat.min");

// Dark mode favicon
const faviconDark = require("Images/favicon_white.png");

// Global app styles (after external libs)
require("Styles/global.scss");

import LanguageManager from "Sources/services/language-manager";
import utils from "Sources/utils/utils";
import NavUtils from "Sources/utils/navigation-utils";
import Dialog from "Sources/utils/modal";
import MaterialService from "./services/material-service";
import CurriculumObjectiveService from "./services/curriculum-objective-service";
import MediaAssetService from "./services/media-asset-service";
import StorageController from "./controllers/storage-controller";
import CookieConsentController from "./controllers/cookieconsent-controller";
const log = require("Sources/utils/logger")();

let Shared = {};

((Shared) =>
{
  Shared.init = function()
  {
    if(Shared.isOutdated())
    {
      log.info("Browser is outdated, redirecting to /outdated");
      utils.redirect("/outdated");
    }

    let userData = Shared.getUserData();

    if(utils.isNotNull(userData))
    {
      log.info("User: %o", userData);
    }

    if(__DEVELOPMENT__)
    {

    }
    else
    {
      // if(utils.isNotNull(userData))
      // {
      //   ga("set", "userId", userData.userKey);
      //   ga("set", "dimension1", userData.userKey);
      // }
      //
      // ga("send", "pageview");
    }

    setUpMatchMedia();

    // Set default nav link highlight (try to find it based on current path
    NavUtils.setNavHighlight();

    setUpFragmentImages();

    LanguageManager.init();
  };

  LanguageManager.onInitGlobal = function()
  {
      /*
    try
    {
      cookieconsent.initialise({
        palette: {
          popup: {
            background: "#222222",
            text: "#ffffff"
          },
          button: {
            background: "#e41d36",
            text: "#ffffff"
          }
        },
        theme: "classic",
        content: {
          message: LanguageManager.getValueForKey("cookies.message"),
          dismiss: LanguageManager.getValueForKey("cookies.button.text"),
          link: LanguageManager.getValueForKey("cookies.link.text"),
          href: LanguageManager.getValueForKey("cookies.link")
        }
      });
    }
    catch(e)
    {
      console.error(e);
    }
       */

      CookieConsentController.initialize();
  };

  Shared.isOutdated = function()
  {
    return !Modernizr.filereader;
  };

  Shared.getUserData = function()
  {
    if(utils.isNullOrEmpty(StorageController.getFromSession("data-user"))
      || utils.isNullOrEmpty(StorageController.getFromSession("data-user")).data
      || utils.isUndefined(StorageController.getFromSession("data-user")).data)
    {
      if($("#logged-in-user-data")[0])
      {
        let userData = JSON.parse(decodeURIComponent($("#logged-in-user-data").attr("data-user")));
        StorageController.saveToSession("data-user", userData);
        return userData;
      }
    }
    else
    {
      if(utils.isNotNull(StorageController.getFromSession("data-user")))
      {
        return JSON.parse(StorageController.getFromSession("data-user"));
      }
    }

    return null;
  };

  Shared.updateUserData = function(data)
  {
    StorageController.saveToSession("data-user", data);
  }

  Shared.isLoggedIn = function()
  {
    return utils.isNotNull(Shared.getUserData());
  };

  function setUpFragmentImages()
  {
    /*
    let headerLogo = require("Images/header/circonopoly-logo.png");
    // let footerLogo = require("Images/footer/cartamundi-logo.png");

    $("#header-brand").append("<img src='" + headerLogo + "' alt='Circonopoly'/>");
    // $("#footer-main-logo").append("<img src='" + footerLogo + "'/>");
    */
  }

  function setUpMatchMedia()
  {
    // Matches the favicon to the current preferred color scheme

    if(!utils.isFunction(window.matchMedia))
    {
      return;
    }

    const faviconDarkLink = document.createElement("link");
    faviconDarkLink.setAttribute("rel", "favicon icon");
    faviconDarkLink.setAttribute("type", "image/png");
    faviconDarkLink.setAttribute("media", "(prefers-color-scheme:dark)");
    faviconDarkLink.setAttribute("href", faviconDark);
    document.head.appendChild(faviconDarkLink);

    const links = collectLinks();

    let current = document.createElement("link");
    current.setAttribute("rel", "shortcut icon");
    document.head.appendChild(current);

    function faviconApplyLoop()
    {
      links.forEach(function(link) {
        if(window.matchMedia(link.media).matches)
        {
          current.setAttribute("type", link.getAttribute("type"));
          current.setAttribute("href", link.getAttribute("href"));
        }
      })
    }

    faviconApplyLoop();
    links.forEach(function(link)
    {
      document.head.removeChild(link);
    });

    let lightMediaMatch = window.matchMedia("(prefers-color-scheme:light)");
    let darkMediaMatch = window.matchMedia("(prefers-color-scheme:dark)");

    if(utils.isFunction(lightMediaMatch.addEventListener))
    {
      /*
        This is basically an alias for EventTarget.addEventListener(), for backwards compatibility purposes.
        Older browsers should use addListener instead of addEventListener since MediaQueryList only inherits from EventTarget in newer browsers.
      */

      lightMediaMatch.addEventListener("change", function(e)
      {
        if(!e.matches) return;
        faviconApplyLoop();
      });

      darkMediaMatch.addEventListener("change", function(e)
      {
        if(!e.matches) return;
        faviconApplyLoop();
      });
    }
    else
    {
      // noinspection JSDeprecatedSymbols
      lightMediaMatch.addListener(function(e)
      {
        if(!e.matches) return;
        faviconApplyLoop();
      });

      // noinspection JSDeprecatedSymbols
      darkMediaMatch.addListener(function(e)
      {
        if(!e.matches) return;
        faviconApplyLoop();
      });
    }
  }

  function collectLinks()
  {
    return Array.prototype.slice.apply(document.head.querySelectorAll("link[rel*='icon']"));
  }

  //#region Materials and categories
  Shared.getAllMaterials = function()
  {
    return new Promise(function(resolve, reject){

      if(StorageController.getFromSession("materials") === null)
      {
        MaterialService.getAllMaterials()
          .then(missionMaterials => {
            StorageController.saveToSession("materials", missionMaterials);
            resolve(missionMaterials);
          })
          .catch((appError) =>
          {
            Error(appError);
            log.error("could not get materials");
          });
      }
      else
      {
        let materials = JSON.parse(StorageController.getFromSession("materials"));
        if(utils.isNullOrEmpty(materials) || utils.isUndefined(materials))
        {
          MaterialService.getAllMaterials()
            .then(missionMaterials => {
              StorageController.saveToSession("materials", missionMaterials);
              resolve(missionMaterials);
            })
            .catch((appError) =>
            {
              Error(appError);
              log.error("could not get materials");
            });
        }
        else
        {
          resolve(materials);
        }

      }
    });
  }

  Shared.getAllMaterialCategories = function()
  {
    return new Promise(function(resolve, reject){

      if(StorageController.getFromSession("material-categories") === null)
      {
        MaterialService.getAllMaterialCategories()
          .then(materialCategories => {
            StorageController.saveToSession("material-categories", materialCategories);
            resolve(materialCategories);
          })
          .catch((appError) =>
          {
            Error(appError);
            log.error("could not get categories");
          });
      }
      else
      {
        let categories = JSON.parse(StorageController.getFromSession("material-categories"));
        if(utils.isNullOrEmpty(categories) || utils.isUndefined(categories))
        {
          MaterialService.getAllMaterialCategories()
            .then(materialCategories => {
              StorageController.saveToSession("material-categories", materialCategories);
              resolve(materialCategories);
            })
            .catch((appError) =>
            {
              Error(appError);
              log.error("could not get categories");
            });
        }
        else
        {
          resolve(categories);
        }
      }
    });
  }
  //#endregion

  //#region Curriculum objectives
  Shared.getAllObjectives = function()
  {

    return new Promise(function(resolve, reject){

      if(StorageController.getFromSession("objectives") === null)
      {
        CurriculumObjectiveService.getAllCurriculumObjectives()
          .then(objectives => {
            StorageController.saveToSession("objectives", objectives);
            resolve(objectives);
          })
          .catch((appError) =>
          {
            Error(appError);
            log.error("could not get objectives");
          });
      }
      else
      {
        let objectives = JSON.parse(StorageController.getFromSession("objectives"));
        if(utils.isNullOrEmpty(objectives) || utils.isUndefined(objectives))
        {
          CurriculumObjectiveService.getAllCurriculumObjectives()
            .then(objectives => {
              StorageController.saveToSession("objectives", objectives);
              resolve(objectives);
            })
            .catch((appError) =>
            {
              Error(appError);
              log.error("could not get objectives");
            });
        }
        else
        {
          resolve(objectives);
        }

      }
    });
  }

  Shared.getAllObjectiveCategories = function()
  {
    /*
    //Temporary fake
    return new Promise(function(resolve, reject) {
      resolve([
        {key: "abcd", localizationKey: "objective_category_technology", name:"Technologie"},
        {key: "efgh", localizationKey: "objective_category_collaboration", name:"Samenwerken"}
        ]);
    });

     */

    return new Promise(function(resolve, reject){

      if(StorageController.getFromSession("objective-categories") === null)
      {
        CurriculumObjectiveService.getAllCurriculumCategories()
          .then(objectiveCategories => {
            StorageController.saveToSession("objective-categories", objectiveCategories);
            resolve(objectiveCategories);
          })
          .catch((appError) =>
          {
            Error(appError);
            log.error("could not get categories");
          });
      }
      else
      {
        let categories = JSON.parse(StorageController.getFromSession("objective-categories"));
        if(utils.isNullOrEmpty(categories) || utils.isUndefined(categories))
        {
          CurriculumObjectiveService.getAllCurriculumCategories()
            .then(objectiveCategories => {
              StorageController.saveToSession("objective-categories", objectiveCategories);
              resolve(objectiveCategories);
            })
            .catch((appError) =>
            {
              Error(appError);
              log.error("could not get categories");
            });
        }
        else
        {
          resolve(categories);
        }
      }
    });
  }
  //#endregion

  //#region Avatars
  Shared.getAllAvatars = function()
  {
    return new Promise(function(resolve, reject){

      if(StorageController.getFromSession("avatars") === null)
      {
        MediaAssetService.getAvatars()
          .then(avatars => {
            StorageController.saveToSession("avatars", avatars);
            resolve(avatars);
          })
          .catch((appError) =>
          {
            Error(appError);
            log.error("could not get avatars");
          });
      }
      else
      {
        let avatars = JSON.parse(StorageController.getFromSession("avatars"));

        if(utils.isNullOrEmpty(avatars) || utils.isUndefined(avatars))
        {
          MediaAssetService.getAvatars()
            .then(avatars => {
              StorageController.saveToSession("avatars", avatars);
              resolve(avatars);
            })
            .catch((appError) =>
            {
              Error(appError);
              log.error("could not get avatars");
            });
        }
        else
        {
          resolve(avatars);
        }

      }
    });
  }

  //#endregion

  //#region Session Thumbs

  Shared.getAllSessionThumbs = function()
  {

    return new Promise(function(resolve, reject){

      if(StorageController.getFromSession("session_thumbs") === null)
      {
        MediaAssetService.getThumbs()
          .then(thumbs => {
            StorageController.saveToSession("session_thumbs", thumbs);
            resolve(thumbs);
          })
          .catch((appError) =>
          {
            Error(appError);
            log.error("could not get thumbs");
          });
      }
      else
      {
        let thumbs = JSON.parse(StorageController.getFromSession("session_thumbs"));
        if(utils.isNullOrEmpty(thumbs) || utils.isUndefined(thumbs))
        {
          MediaAssetService.getThumbs()
            .then(thumbs => {
              StorageController.saveToSession("session_thumbs", thumbs);
              resolve(thumbs);
            })
            .catch((appError) =>
            {
              Error(appError);
              log.error("could not get thumbs");
            });
        }
        else
        {
          resolve(thumbs);
        }

      }
    });
  }

  Shared.setupGameboardCodeInput = function(selector)
  {
    let input = $(selector);

    input.attr("placeholder", "XXXX-XXXX-XXXX");
    input.attr("maxlength", "14");

    input.on("keyup", function(e)
    {
      // Don't do anything if the user presses backspace (8) or delete (46)
      let key = e.keyCode || e.charCode;
      if (key === 8 || key === 46)
      {
        return;
      }

      // Remove all "-" from the string and insert them again in the correct positions

      let text = $(this).val().replace(/\-/g, "");

      if (text.length >= 4)
      {
        text = text.substring(0, 4) + "-" + text.substring(4);
      }

      if (text.length >= 9)
      {
        text = text.substring(0, 9) + "-" + text.substring(9);
      }

      $(this).val(text.toUpperCase());
    });
  };

  //#endregion

  Shared.Dialog = Dialog;

  return Shared;
})(Shared);

module.exports = Shared;



// WEBPACK FOOTER //
// ./app/js/shared.js